export enum LoginMethod {
    Manual = 0,
    Third = 1,
  }